export enum WidgetLocation {
	"SIDE",
	"EVENT_OFFER",
}
